import { bootstrapCoursematrix } from './coursematrix';
import { bootstrapModalTypes } from './modal-types';
import { disableVideoDownload } from './misc';

export function bootstrap() {
  console.debug('bootstrap')
  disableVideoDownload()

  bootstrapCoursematrix()
  bootstrapModalTypes()
}
